/*
  Pfad: /src/pages/stb/Stb_adv_translate.js
  Funktion: GPT-gestützte Übersetzung einer Stellenanzeige DE -> EN oder EN -> DE
*/

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Input } from '../../components/ui/input.jsx';
import { Button } from '../../components/ui/button.jsx';
import { Textarea } from '../../components/ui/textarea.jsx';
import { Card, CardContent } from '../../components/ui/card.jsx';



const Stb_adv_translate = () => {
  const { adv_id } = useParams();
  const [übersetzung, setÜbersetzung] = useState("");
  const [loading, setLoading] = useState(false);

  const starteÜbersetzung = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/gpt/translate-adv`, {
        adv_id,
        zielsprache: "en" // Standardmäßig ins Englische übersetzen
      });
      setÜbersetzung(res.data.translation);
    } catch (err) {
      console.error("Fehler bei Übersetzung:", err);
      alert("Fehler bei der GPT-Übersetzung.");
    }
    setLoading(false);
  };

  useEffect(() => {
    starteÜbersetzung();
  }, [adv_id]);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Stellenanzeige übersetzen</h1>

      <Card className="shadow-lg">
        <CardContent className="p-6">
          {loading ? (
            <p className="text-blue-500">GPT übersetzt...</p>
          ) : (
            <pre className="whitespace-pre-wrap text-gray-800">{übersetzung}</pre>
          )}
        </CardContent>
      </Card>

      <div className="mt-6 text-center">
        <Button onClick={starteÜbersetzung} variant="outline">Neu übersetzen</Button>
      </div>
    </div>
  );
};

export default Stb_adv_translate;
